module.exports = __webpack_public_path__ + "fonts/60fa3c0.woff";